"use client";

import { Plus } from "lucide-react";

export default function FaqItem({ question, answer }: { question: string; answer: string }) {
    return (
        <details className="group py-6 first:pt-0 last:pb-0">
            <summary className="flex items-center justify-between cursor-pointer list-none [&::-webkit-details-marker]:hidden">
                <h3 className="text-lg font-bold text-ink pr-8 font-display">{question}</h3>
                <span className="text-accent-blue transition-transform duration-300 group-open:rotate-45 shrink-0">
                    <Plus size={24} />
                </span>
            </summary>
            <div className="pt-4 text-ink/70 text-lg leading-relaxed animate-in slide-in-from-top-2 duration-200">
                <p>{answer}</p>
            </div>
        </details>
    );
}
